<template>
  <img
    v-if="code?.length === 3"
    class="self-center border border-gray-300 rounded-[4px] object-cover object-[50%_-0px]"
    :alt="`${t('Country')}: ${country || code}`"
    :src="getFlagUrl(code)"
    :class="small ? 'w-5 rectangle-full' : big ? 'w-10 rectangle-full' : 'w-8 rectangle-full'" />
</template>
<script setup>
import { getFlagUrl, t } from "@xs2event/js-lib/util";

defineProps({
  code: { required: true, type: String },
  big: Boolean,
  small: Boolean,
  country: { required: false, type: String, default: "" },
});
</script>
